import request from '@/utils/request'
export function fetchList(params) {
  return request({
    url:'/article/list',
    method:'get',
    params:params
  })
}
export function createArticle(data) {
  return request({
    url:'/article/create',
    method:'post',
    data:data
  })
}
export function updateVerifyStatus(data) {
  return request({
    url:'/article/update/verifyStatus',
    method:'post',
    data:data
  })
}
export function updateShowStatus(data) {
  return request({
    url:'/article/update/showStatus',
    method:'post',
    data:data
  })
}
export function updateArticleClick(data) {
  return request({
    url:'/article/updateclick',
    method:'post',
    data:data
  })
}
export function updateDeleteStatus(params) {
  return request({
    url:'/article/delete/batch',
    method:'post',
    params:params
  })
}
export function deleteArticle(id) {
  return request({
    url:'/article/delete/'+id,
    method:'get',
  })
}

export function getArticle(id) {
  return request({
    url:'/article/'+id,
    method:'get',
  })
}

export function updateArticle(id,data) {
  return request({
    url:'/article/update/'+id,
    method:'post',
    data:data
  })
}
export function updateHomeHtml() {
  return request({
    url:'/home/html/update',
    method:'post'
  })
}
export function updataListRight() {
  return request({
    url:'/home/html/update_list_right',
    method:'post'
  })
}
export function updataTop() {
  return request({
    url:'/home/html/update_top',
    method:'post'
  })
}
export function updataFooter() {
  return request({
    url:'/home/html/update_footer',
    method:'post'
  })
}
export function updatachannelActivity(id) {
  return request({
    url:'/articleCategory/list/html/'+id,
    method:'post'
  })
}




// WEBPACK FOOTER //
// ./src/api/article.js